class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.activeVolumeLevel = 1;
    this.initialized = false;
    this.isFullscreenMode = false; // Added for tracking fullscreen state
    this.init();
    this.addEventListeners();
    if (this.playing) this.play();
    this.initialized = true;
  }

  init = () => {
    this.SELECTORS = {
      video: "video",
      playButton: ".play-button",
      volumeButton: ".volume-button",
      volumeLevel: ".volume-level",
      seeker: ".seeker",
      passedTimeDisplay: ".seeker .passed",
      totalTimeDisplay: ".seeker .total",
      inputSeeker: ".input-seeker",
      fullScreenBtn: ".fullscreen-btn",
      fullscreenControls: ".fullscreen-controls",
      subTitleBtn: ".subtitle-btn",
      customSubtitles: ".custom-subtitles",
      exitBtnVidepPlayer: ".exit-btn-videoplayer",
      atmosphericPlayButton: "button.athmospheric-play",
      controls: ".controls" // Added for controls reference
    };
    this.video = this.querySelector(this.SELECTORS.video);
    this.playing = this.video.attributes.autoplay;
    this.playButtons = [...this.querySelectorAll(this.SELECTORS.playButton)];
    this.volumeButtons = [...this.querySelectorAll(this.SELECTORS.volumeButton)];
    this.volumeContriner = this.querySelector(".volume");
    this.volumeLevel = this.querySelector(this.SELECTORS.volumeLevel);
    this.seeker = this.querySelector(this.SELECTORS.seeker);
    this.passedTimeDisplay = this.querySelector(this.SELECTORS.passedTimeDisplay);
    this.totalTimeDisplay = this.querySelector(this.SELECTORS.totalTimeDisplay);
    this.fullScreenBtns = [...this.querySelectorAll(this.SELECTORS.fullScreenBtn)];
    this.inputSeeker = this.querySelector(this.SELECTORS.inputSeeker);
    this.fullscreenControls = this.querySelector(this.SELECTORS.fullscreenControls);
    this.subTitleBtn = this.querySelector(this.SELECTORS.subTitleBtn);
    this.track = this.video.textTracks[0];
    this.customSubtitles = this.querySelector(this.SELECTORS.customSubtitles);
    this.exitBtnVidepPlayer = this.querySelector(this.SELECTORS.exitBtnVidepPlayer);
    this.atmosphericPlayButton = this.querySelector(this.SELECTORS.atmosphericPlayButton);
    this.controls = this.querySelector(this.SELECTORS.controls);
  };

  addEventListeners = () => {
    this.playButtons.map((el) => {
      el.addEventListener("click", this.playPause);
    });
    this.addEventListener("mouseenter", this.addHover);
    this.addEventListener("mousemove", this.addHover);
    this.addEventListener("mouseleave", this.removeHover);
    this.volumeButtons?.map((el) => {
      el.addEventListener("click", this.volumeToggle);
    });

    // Add click handler for atmospheric play button
    if (this.atmosphericPlayButton) {
      this.atmosphericPlayButton.addEventListener("click", this.handleAtmosphericPlayClick);
    }

    // For non-atmospheric videos
    if (!this.atmosphericPlayButton) {
      this.volumeLevel?.addEventListener("input", this.handleVolumeChange);
      this.seeker?.addEventListener("input", this.handleSeek);
      this.video?.addEventListener("timeupdate", this.updateSeekerValue);
      this.fullScreenBtns?.map((el) => {
        el.addEventListener("click", this.toggleFullScreen);
      });
      this.subTitleBtn?.addEventListener("click", this.toggleSubtitles);
      this.track?.addEventListener("cuechange", this.handleCueChange);
      this.exitBtnVidepPlayer?.addEventListener("click", this.exitVideoPlayer);
    }
  };

  // New method to handle atmospheric play button click
  handleAtmosphericPlayClick = (e) => {
    e.stopPropagation();
    if (!this.isFullscreenMode) {
      this.atmosphericPlayButton.classList.toggle("paused");
      this.playing ? this.pause() : this.play();
    }
  };

  enterFullscreenMode = () => {
    if (!this.isFullscreenMode) {
      this.isFullscreenMode = true;
      this.requestFullscreen();
      this.video.muted = false;
      if (this.controls) {
        this.controls.style.display = 'flex';
      }
      this.classList.add("with-controls");

      // Add control event listeners for atmospheric video
      this.volumeLevel?.addEventListener("input", this.handleVolumeChange);
      this.seeker?.addEventListener("input", this.handleSeek);
      this.video?.addEventListener("timeupdate", this.updateSeekerValue);
      this.fullScreenBtns?.forEach((el) => {
        el.addEventListener("click", this.toggleFullScreen);
      });
      this.exitBtnVidepPlayer?.addEventListener("click", this.exitVideoPlayer);
    }
  };

  addHover = (e) => {
    this.classList.add("hovered");
  };

  removeHover = (e, delay = 1000) => {
    setTimeout(() => {
      this.classList.remove("hovered");
    }, delay);
  };

  playPause = (e) => {
    this.scrollIntoView({ behavior: "smooth" });
    if (
      e.target.classList.contains("volume-button") ||
      e.target.classList.contains("volume-level") ||
      e.target.classList.contains("input-seeker") ||
      e.target.classList.contains("subtitle-btn") ||
      e.target.classList.contains("fullscreen-btn") ||
      e.target.classList.contains("exit-btn-videoplayer")
    )
      return;
    e.stopPropagation();
    this.playing ? this.pause() : this.play();
  };

  play = () => {
    try {
      this.video.play();
      this.classList.add("playing");
      this.playing = true;
      this.initialized && document.dispatchEvent(new Event("hideheader"));
      this.removeHover(null, 0);
    } catch (ex) {
      console.warn(ex);
    }
  };

// Update play/pause methods to handle button state
play = () => {
  try {
    this.video.play();
    this.classList.add("playing");
    this.playing = true;
    if (this.atmosphericPlayButton) {
      // Show pause icon when playing
      this.atmosphericPlayButton.classList.remove("paused");
    }
    this.initialized && document.dispatchEvent(new Event("hideheader"));
    this.removeHover(null, 0);
  } catch (ex) {
    console.warn(ex);
  }
};

pause = () => {
  try {
    this.video.pause();
    document.dispatchEvent(new Event("showheader"));
    this.classList.remove("playing");
    this.playing = false;
    if (this.atmosphericPlayButton) {
      // Show play icon when paused
      this.atmosphericPlayButton.classList.add("paused");
    }
  } catch (ex) {
    console.warn(ex);
  }
};


  updateVolumeIcon = (level) => {
    const isMuted = this.volumeContriner.classList.contains("muted");
    if ((level == 0 && !isMuted) || (level > 0 && isMuted)) {
      this.volumeContriner.classList.toggle("muted");
    }
  };

  handleVolumeChange = (e) => {
    const level = e.target.value;
    this.setVolumeLevel(level);
    this.activeVolumeLevel = level;
  };

  volumeToggle = () => {
    try {
      if (this.video.volume > 0) {
        this.muteVolume();
      } else {
        this.unmuteVolume();
      }
    } catch (ex) {
      console.warn(ex);
    }
  };

  muteVolume = () => {
    this.setVolumeLevel(0);
    this.volumeLevel.value = 0;
  };

  unmuteVolume = () => {
    this.setVolumeLevel(this.activeVolumeLevel);
    this.volumeLevel.value = this.activeVolumeLevel;
  };

  handleSeek = (e) => {
    this.video.currentTime = e.target.value;
  };

  updateSeekerMax = () => {
    try {
      this.seeker.max = this.video.duration;
      this.totalTimeDisplay.textContent = this.formatTime(this.video.duration);
    } catch (ex) {
      console.warn(ex);
    }
  };

  updateSeekerValue = () => {
    let currentTime = this.video.currentTime;
    this.seeker.value = currentTime;
    this.inputSeeker.value = currentTime;
    this.passedTimeDisplay.textContent = this.formatTime(currentTime);
    this.updateSeekerMax();
  };

  formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  toggleFullScreen = () => {
    this.fullscreenControls.classList.toggle("active");
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      this.requestFullscreen();
    }
  };

  toggleSubtitles = () => {
    this.subTitleBtn.classList.toggle("active");
    let track = this.video.textTracks[0];
    if (track.mode === "showing") {
      track.mode = "hidden";
      this.customSubtitles.classList.add("hidden");
    } else {
      track.mode = "showing";
      this.customSubtitles.classList.remove("hidden");
    }
  };

  exitVideoPlayer = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
    this.isFullscreenMode = false;
    if (this.controls) {
      this.controls.style.display = 'none';
    }
    this.classList.remove("with-controls");
    
    if (this.atmosphericPlayButton) {
      this.video.muted = true;
      this.play(); // Continue playing in background
    } else {
      this.pause();
    }
    
    this.closest(".image-banner")
      .querySelector(".image-banner-content")
      .classList.remove("hidden");
  };

  handleTogglePauseAtmospheric = () => {
    this.atmosphericPlayButton.classList.toggle("paused");
    if (!this.isFullscreenMode) {
      this.enterFullscreenMode();
    }
    this.playing ? this.pause() : this.play();
  };

  handleCueChange = () => {
    var activeCues = this.track.activeCues;
    if (activeCues.length > 0) {
      for (var i = 0; i < activeCues.length; i++) {
        this.customSubtitles.textContent = activeCues[i].text;
      }
    } else {
      this.customSubtitles.textContent = "";
    }
  };
}

customElements.define("video-player", VideoPlayer);

function openVideoPlayerEventListener() {
  const openVideoPlayerButtons = document.querySelectorAll("li[open-vidoe-btn]");
  openVideoPlayerButtons.forEach((el) => {
    el.addEventListener("click", () => {
      const imageBanner = el.closest(".image-banner");
      const imageBannerContent = imageBanner.querySelector(".image-banner-content");
      const videoPlayer = imageBanner.querySelector("video-player");
      
      videoPlayer.scrollIntoView({ behavior: "smooth" });
      if (imageBannerContent) imageBannerContent.classList.add("hidden");
      
      // Enter fullscreen mode with controls for atmospheric videos
      if (videoPlayer.atmosphericPlayButton) {
        videoPlayer.enterFullscreenMode();
      }
      videoPlayer.play();
    });
  });
}

openVideoPlayerEventListener();